<div id="main-form">
  <!-- CONTENEDOR -->
  <div class="item-section">
    <div class="title">
      <p class="heading-02-bold grey-900">Propiedad</p>
    </div>
    <!-- Content PROPIEDAD -->
    <div class="content-section">
      <!---------------------------------------------------------------- -->
      <!--/////// SELECCIÓN DE RESERVA | NO-RESULTS PARA RESERVA ////////-->
      <!---------------------------------------------------------------- -->

      <ng-container *ngIf="!showSearchListings()">
        <!-- ---------- TOGGLE ORIGEN → [Reserva / Nueva] ---------- -->
        <div class="item-form" *ngIf="!IS_AR && !IS_DO">
          <div class="item-label">
            <p>Origen</p>
          </div>
          <div class="origin-toggle-container">
            <qr-toggle
              [config]="originToggle"
              (change)="onChangeOrigin($event)"
            ></qr-toggle>
          </div>
        </div>

        <!-- ----------- DIRECCION RESERVA / MLSD-ID RESERVA ----------- -->
        <div class="item-form">
          <div class="item-label">
            <p>
              Dirección
              {{ originToggle.optionSelected === 0 ? "/ MLS-ID" : "" }}
            </p>
          </div>
          <div class="direction-mlsid-container">
            <qr-input-autocomplete
              *ngIf="originToggle.optionSelected === 0"
              class="input-autocomplete"
              [config]="inputDirectionMlsId"
              [isDisabled]="inputDirectionMlsId.options.length === 0"
              (selectedChange)="directionMlsIdChange($event)"
              (noResults)="noReserveResults = $event"
            ></qr-input-autocomplete>
            <qr-input
              *ngIf="originToggle.optionSelected === 1"
              class="input-autocomplete"
              [config]="inputDirectionNew"
              (valueChange)="changeInputDirectionNew($event)"
            ></qr-input>
            <qr-button
              [isLoading]="this.needsToLoad"
              id="confirm-btn"
              [config]="buttonConfirm"
              (click)="onClickConfirm()"
              [isDisabled]="noReserveResults || reservations.length === 0"
            ></qr-button>
          </div>
        </div>

        <!--  ----------- NO RESULTADOS DE BUSQUEDA -----------  -->
        <!-- --------- CREAR RESERVA / BUSCAR CAPTACIÓN -------- -->
        <div class="no-results-reservation" *ngIf="showNoResultsReservations()">
          <!-- CREAR RESERVA -->
          <div class="create-reserve-box">
            <h4 class="title-empty">
              No se encontró
              {{ reservations.length === 0 ? "reservas" : "la reserva" }} en
              gestión
            </h4>
            <p>
              Proceder sin generar una reserva puede tener un impacto negativo
              en las estadísticas de tus agentes, tu oficina y el resto de la
              red. Es altamente recomendable seguir el proceso correcto para
              evitar estos inconvenientes.
            </p>
            <qr-button
              [config]="buttonGoReservationForm"
              (click)="goReserveForm()"
            ></qr-button>
          </div>

          <!-- BUSCAR CAPTACIÓN EN LISTINGS -->
          <div class="search-catchment-box">
            <p>
              También puede buscar la captación por MLS-ID o dirección en RE/MAX
              <br />
              o registrar una operacion con otra inmobiliaria
            </p>
            <qr-button
              [config]="buttonSearchCatchment"
              (click)="isVisibleSearchListing = true"
            ></qr-button>
          </div>
        </div>
      </ng-container>

      <!------------------------------------------------------------------- -->
      <!--//////// BUSCADOR DE CAPTACIÓN EN LISTINGS | OTRA INMOB. /////////-->
      <!------------------------------------------------------------------- -->
      <!-- (Pueden buscar la captación en REMAX o elegir "Otra inmobiliria")-->

      <ng-container *ngIf="showSearchListings()">
        <!-- -------- TOGGLE ORIGEN: [RE/MAX | Otro | Nueva] --------  -->
        <div class="item-form">
          <div class="item-label">
            <p>Origen</p>
          </div>
          <div class="origin-lite-version-toggle">
            <qr-toggle
              [config]="originToggleLite"
              (change)="onChangeOriginSearch()"
            ></qr-toggle>
          </div>
        </div>

        <!--  ----------- TOGGLE → "RE/MAX" -----------  -->
        <ng-container *ngIf="showToggleOriginSearch()">
          <!-- OFICINA -->
          <div class="item-form" *ngIf="originToggleLite.optionSelected === 0">
            <div class="item-label"><p>Oficina</p></div>
            <!-- LISTADO DE OFICINAS -->
            <qr-input-autocomplete
              *ngIf="!officeSelected"
              class="office-list-autocomplete"
              [config]="autocompleteOfficeList"
              (selectedChange)="autocompleteOfficeListChanges($event)"
            ></qr-input-autocomplete>
            <!-- OFICINA ELEGIDA -->
            <qr-chip
              *ngIf="officeSelected"
              class="chip"
              [config]="chipHierarchy2CleanButton"
              [value]="'RE/MAX ' + officeSelected.name.toUpperCase()"
              (dispatchClean)="cleanChipOffice($event)"
            ></qr-chip>
          </div>

          <!-- BUSCAR POR MLSID O ADRESS -->
          <div
            class="item-form"
            *ngIf="
              (IS_AR && officeSelected) ||
              (IS_DO &&
                [0, 1].includes(originToggleLite.optionSelected) &&
                officeSelected)
            "
          >
            <div class="item-label"><p>Buscar propiedad</p></div>
            <div class="selection-box-container">
              <!-- MLSID -->
              <div
                class="mlsid-search-box"
                [ngClass]="{ active: selectionBoxSearch === 0 }"
                (click)="selectMlsidOrAddress(0)"
              >
                <div class="label-search-box">MLS-ID</div>
                <div
                  class="input-container"
                  [ngStyle]="{
                    'pointer-events': selectionBoxSearch === 0 ? 'auto' : 'none'
                  }"
                >
                  <qr-input-autocomplete-with-service
                    [config]="autocompleteMlsid"
                    (selectedChange)="mlsidSelectedChange($event)"
                    (writtenText)="mlsidForSearchChange($event)"
                    [isDisabled]="selectionBoxSearch === 1"
                    [isLoading]="isLoadingSearchService"
                    [noResults]="noResultsForMlsid"
                  ></qr-input-autocomplete-with-service>
                  <qr-button
                    [config]="buttonSearchMLSID"
                    (click)="onClickSearchByMlsid()"
                    [isDisabled]="selectionBoxSearch === 1"
                    [ngStyle]="{
                      'pointer-events': mlsidWritten === '' ? 'none' : 'auto'
                    }"
                  ></qr-button>
                </div>
              </div>
              <!-- ADDRESS -->
              <div
                class="address-search-box"
                [ngClass]="{ active: selectionBoxSearch === 1 }"
                (click)="selectMlsidOrAddress(1)"
              >
                <div class="label-search-box">Dirección</div>
                <div
                  class="input-container"
                  [ngStyle]="{
                    'pointer-events': selectionBoxSearch === 1 ? 'auto' : 'none'
                  }"
                >
                  <qr-input-autocomplete-with-service
                    [config]="autocompleteAddress"
                    [multilineAddressOptions]="true"
                    (selectedChange)="addressSelectedChange($event)"
                    (writtenText)="addressForSearchChange($event)"
                    [isDisabled]="selectionBoxSearch === 0"
                    [isLoading]="isLoadingSearchService"
                    [noResults]="noResultsForAddress"
                  ></qr-input-autocomplete-with-service>
                </div>
              </div>
            </div>
          </div>

          <!-- ------------- PROPIEDAD ELEGIDA ------------- -->
          <div class="item-form" *ngIf="propertySelected">
            <div class="item-label"><p>Dirección / MLS-ID</p></div>
            <div class="property-selected">
              <div class="address">{{ propertySelected.address }}</div>
              <div class="mlsid">{{ propertySelected.mlsid }}</div>
            </div>
          </div>
          <div class="confirm-btn-container" *ngIf="propertySelected">
            <qr-button
              [isLoading]="needsToLoad"
              [config]="buttonConfirm"
              (click)="onClickConfirmLite()"
            ></qr-button>
          </div>
        </ng-container>

        <!--  ----------- TOGGLE → "OTRO" -----------  -->
        <ng-container
          *ngIf="
            (IS_AR && originToggleLite.optionSelected === 1) ||
            (IS_DO && originToggleLite.optionSelected === 2)
          "
        >
          <div class="item-form">
            <div class="item-label"><p>Dirección</p></div>
            <div class="direction-mlsid-container">
              <qr-input
                class="input-autocomplete"
                [config]="inputDirectionNew"
                (valueChange)="changeInputDirectionNew($event)"
              ></qr-input>
              <qr-button
                class="standard-btn"
                [isLoading]="needsToLoad"
                id="confirm-btn"
                [config]="buttonConfirm"
                (click)="onClickConfirm()"
              ></qr-button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<qr-dialog
  [config]="dialogLoadDraft"
  (dialogChange)="dialogChangeLoadDraft($event)"
></qr-dialog>

<app-loader-full-screen *ngIf="isLoadingOfficeList"></app-loader-full-screen>
